import { CommonEnums } from '../common.enums';
import { Obj_Db_Property } from '../models/datapoint/obj_db_property';
import { ListFactory } from '../caches/list.factory';
import { ServiceManager } from '../services/service.manager';
export class Obj_Db_PropertyUtil {
    private static instance: Obj_Db_PropertyUtil;
    Obj_Db_Property: Obj_Db_Property;
    listFactory: ListFactory;
    serviceManager: ServiceManager;
    showOnPropertyValueCds: Array<any>;

    static getInstance() {
        if (!Obj_Db_PropertyUtil.instance) {
            Obj_Db_PropertyUtil.instance = new Obj_Db_PropertyUtil();
        }

        return Obj_Db_PropertyUtil.instance;
    }

    /**
    * Obj_Db_PropertyUtil is a singleton class, so use Obj_Db_PropertyUtil.getInstance() method instead of creating new Obj_Db_PropertyUtil().
    */
    private constructor() {
        this.Obj_Db_Property = new Obj_Db_Property();
        this.listFactory = ListFactory.getInstance();
        this.showOnPropertyValueCds = new Array<any>();
    }

    add(): Obj_Db_Property {
        return null;
    }

    delete(): void {
    }

    openListObjects(fldr_Id, diMsgObjectEmpty) {
        return this.serviceManager.openListObjects(fldr_Id, diMsgObjectEmpty).subscribe((repconn) => {
            return repconn
        });
    }

    setObj_Db_Property_Defaults(obj_Db_Property: Obj_Db_Property): void {
        obj_Db_Property.conn_Id = CommonEnums.defaults.LONG_VAL;
        obj_Db_Property.dbTyp_Id = CommonEnums.defaults.LONG_VAL;
        obj_Db_Property.el_Type = CommonEnums.defaults.STRING_EMPTY;
        obj_Db_Property.propertyType_Cd = CommonEnums.defaults.STRING_EMPTY;
        obj_Db_Property.propertyVal = CommonEnums.defaults.STRING_EMPTY;
        obj_Db_Property.defaultSel = CommonEnums.defaults.STRING_EMPTY;
        obj_Db_Property.streamingFlg = CommonEnums.defaults.STRING_EMPTY;
        obj_Db_Property.overrideFlg = CommonEnums.defaults.STRING_EMPTY;
        obj_Db_Property.obj_Id = CommonEnums.defaults.LONG_VAL;
        obj_Db_Property.dxMp_Inst_Id = CommonEnums.defaults.LONG_VAL;
        obj_Db_Property.dxFlow_Id = CommonEnums.defaults.LONG_VAL;
        obj_Db_Property.copyPropertyVal = CommonEnums.defaults.STRING_EMPTY;
        obj_Db_Property.srt_Order = CommonEnums.defaults.LONG_VAL;
        obj_Db_Property.copyDefaultSel = CommonEnums.defaults.STRING_EMPTY;
        obj_Db_Property.propertyNm = CommonEnums.defaults.STRING_EMPTY;
        obj_Db_Property.propertyVals = CommonEnums.defaults.STRING_EMPTY;
        obj_Db_Property.validationRule = CommonEnums.defaults.STRING_EMPTY;
        obj_Db_Property.maxChars = CommonEnums.defaults.LONG_VAL;
        obj_Db_Property.description = CommonEnums.defaults.STRING_EMPTY;
        obj_Db_Property.defView = CommonEnums.defaults.STRING_EMPTY;
        obj_Db_Property.propertyValues = new Array<any>();
        obj_Db_Property.showOnProperty = CommonEnums.defaults.STRING_EMPTY;
        obj_Db_Property.showOnProperty_Val = CommonEnums.defaults.STRING_EMPTY;
        obj_Db_Property.showDbType_Id_Property = CommonEnums.defaults.STRING_EMPTY;
        obj_Db_Property.showDbType_Id_Property_Val = CommonEnums.defaults.STRING_EMPTY;
        obj_Db_Property.hasRules = CommonEnums.defaults.STRING_EMPTY;
        obj_Db_Property.hasValRules = CommonEnums.defaults.STRING_EMPTY;
        obj_Db_Property.showOnProperties = new Map();
        obj_Db_Property.showDbType_Id_Properties = new Array<string>();
        obj_Db_Property.showOnProperty_Values = new Map();
        obj_Db_Property.showDbType_Id_Property_Values = new Map();
        obj_Db_Property.showOn = true;
        obj_Db_Property.dobj_Id = CommonEnums.defaults.LONG_VAL;
        obj_Db_Property.propertyReadOnly = CommonEnums.defaults.STRING_EMPTY;
        obj_Db_Property.valid_Cd = CommonEnums.defaults.STRING_EMPTY;
        obj_Db_Property.relevant_DbTyp_Ids = CommonEnums.defaults.STRING_EMPTY;
        obj_Db_Property.fValue = CommonEnums.defaults.STRING_EMPTY;
        obj_Db_Property.sValue = CommonEnums.defaults.STRING_EMPTY;
        obj_Db_Property.propagateValue = CommonEnums.defaults.STRING_EMPTY;
        obj_Db_Property.change_Ind = CommonEnums.defaults.STRING_EMPTY;
        obj_Db_Property.property_level = CommonEnums.defaults.STRING_EMPTY;
        obj_Db_Property.operation = CommonEnums.defaults.STRING_EMPTY;
        obj_Db_Property.runAsOScommand = CommonEnums.defaults.STRING_EMPTY;

    }
}